import { MembershipAnalytics } from '@/components/admin/analyticsV2/membership';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(MembershipAnalytics, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});
